import {
  ConnectedEmpireNavigation,
  Selectors,
  useIsDesktop,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import React from 'react';
import {Platform} from 'react-native';

import ConnectedMyRewardsDesktopHeader from 'containers/MyRewardsDesktopHeader';
import {getSigninUrl, navigateToSignin} from 'utils/signin';

import NavigationDrawer from '../NavigationDrawer';

export interface HeaderContainerProps {
  expanded: boolean;
  onOpen: (isOpen: boolean) => void;
}

const HeaderContainer: React.FC<HeaderContainerProps> = ({
  expanded,
  onOpen,
}) => {
  const isDesktop = useIsDesktop();
  const isLoggedIn = useWidgetState(Selectors.isLoggedInSelector) as boolean;

  const handleLogin = () => {
    const forwardUrl =
      Platform.OS === 'web' ? window.location.pathname : undefined;
    const params = forwardUrl
      ? `forwardUrl=${encodeURIComponent(forwardUrl)}`
      : undefined;
    navigateToSignin(params);
  };

  return isDesktop ? (
    <>
      <ConnectedEmpireNavigation
        onLogin={handleLogin}
        isExpanded={expanded}
        isLoggedIn={isLoggedIn}
        loginLinkHref={getSigninUrl()}
      />
      <ConnectedMyRewardsDesktopHeader />
    </>
  ) : (
    <NavigationDrawer onOpen={onOpen} />
  );
};

export default HeaderContainer;
